module.exports = __webpack_public_path__ + "img/073688.d25a7740.png";